module.exports = __webpack_public_path__ + "static/media/kimtina.8674227f.png";